import styles from './ParameterTile.module.css';

export const ParameterTile = ({
  className,
  title,
  count,
  index = 0,
}: {
  className?: string;
  title?: string;
  count?: string;
  index: number;
}) => {
  return (
    <div
      className={className ? `${styles.root} ${className}` : styles.root}
      style={{ animationDelay: `${index * 20}ms` }}
    >
      <span>{title}</span>
      <span>{count ? '(' + count?.split(' ')[0] + ')' : null}</span>
    </div>
  );
};
